import ApiClient from 'api-client/ApiClient'
// import UpdateAction from 'core/actions/UpdateAction'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
// import DeleteAction from 'core/actions/DeleteAction'
import CustomAction from 'core/actions/CustomAction'
import ListAction from 'core/actions/ListAction'
import { cacheActions } from 'core/caching/cacheReducers'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'

const { dispatch } = store
const { nova } = ApiClient.getInstance()

export const availabilityZoneActions = ActionsSet.make<DataKeys.AvailabilityZones>({
  uniqueIdentifier: 'zoneName',
  entityName: entityNamesByKey.AvailabilityZones,
  cacheKey: DataKeys.AvailabilityZones,
})

export const listAvailabilityZones = availabilityZoneActions.add(
  new ListAction<DataKeys.AvailabilityZones>(async () => {
    const availabilityZones = await nova.getAvailabilityZones()
    return availabilityZones
  }),
)
